import React from "react";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

export function GroupDetailPageSkeleton() {
  return (
    <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
      <Box sx={{ bgcolor: "#FFF", px: 3, py: 2, borderBottom: "1px solid #E5E9EC" }}>
        <Skeleton variant="text" width={200} height={34} />
      </Box>
      <Box sx={{ flex: 1, overflowY: "auto", pt: "32px", px: 3, pb: 3 }}>
        <Box sx={{ maxWidth: 632, width: "100%", mx: "auto" }}>
          <Skeleton variant="rounded" height={96} sx={{ mb: 3, borderRadius: "8px" }} />
          <Skeleton variant="text" width={140} height={34} sx={{ mb: 1.5 }} />
          <Skeleton variant="rounded" height={120} sx={{ mb: 3, borderRadius: "8px" }} />
          <Skeleton variant="text" width={200} height={34} sx={{ mb: 1.5 }} />
          <Skeleton variant="rounded" height={120} sx={{ borderRadius: "8px" }} />
        </Box>
      </Box>
    </Box>
  );
}
